import type { WorkExperienceCompany, WorkExperienceRole } from '@applicator/shared'

/** Active row in work experience / target title (matches checked primary field). */
export const editorTextActiveClass = 'font-medium text-text-primary'

/** Row turned off via its checkbox. */
export const editorTextExcludedClass = 'text-text-muted'

/** Visible list item that is not the single selected summary (still readable, not “disabled”). */
export const editorTextNeutralClass = 'text-text-secondary'

export function companyNameEditorClass(company: WorkExperienceCompany): string {
  return company.included ? editorTextActiveClass : editorTextExcludedClass
}

/** Position label follows the position checkbox, not legacy role.included alone. */
export function rolePositionEditorClass(
  company: WorkExperienceCompany,
  role: WorkExperienceRole,
): string {
  const active = company.included && (role.positionIncluded ?? true)
  return active ? editorTextActiveClass : editorTextExcludedClass
}

export function professionalSummaryEditorClass(included: boolean): string {
  return included ? editorTextActiveClass : editorTextNeutralClass
}

export function targetTitleEditorClass(isSelected: boolean): string {
  return isSelected ? editorTextActiveClass : editorTextNeutralClass
}
